
import React from 'react'
import { useDrag } from 'react-dnd'
import { Fragment, useState } from 'react'
import classNames from 'classnames'
import { Listbox, Transition } from '@headlessui/react'
import { InformationCircleIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/20/solid'
import RotationGateDrawer from './RotationGateDrawer'

export type gateType = {
  id: number,
  color: string,
  child: any,
  type: number,
  isRotationGate?: boolean,
  ratio?: string,
  name: string
}

export type propType = {
  gate: gateType,
  showOptions: boolean,
  deleteGate?: () => void,
  addRatio?: (ratio: string) => void,
  showInfoDrawer?: () => void
}


export const Gate = (props: propType) => {
  const [selected, setSelected] = useState()
  const [showEditModal, setShowEditModal] = useState(false)
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'gate_0',
    item: props.gate,
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  }))
  const publishingOptions = props.gate.isRotationGate ?
    [
      { title: 'Delete', handle: () => props.deleteGate ? props.deleteGate() : null, icon: <TrashIcon className='w-5 h-5 text-red-500' /> },
      { title: 'Edit', handle: () => setShowEditModal(true), icon: <PencilSquareIcon className='w-4 h-4 text-gray-400' /> },
      { title: 'Info', handle: () => props.showInfoDrawer ? props.showInfoDrawer() : null, icon: <InformationCircleIcon className='w-5 h-5 text-gray-400' /> }

    ] :
    [
      { title: 'Delete', handle: () => props.deleteGate ? props.deleteGate() : null, icon: <TrashIcon className='w-5 h-5 text-red-500' /> },
      { title: 'Info', handle: () => props.showInfoDrawer ? props.showInfoDrawer() : null, icon: <InformationCircleIcon className='w-5 h-5 text-gray-400' /> }

    ]

  const addRatio = (data: any) => {
    setShowEditModal(false);
    if (props.addRatio) {
      props.addRatio(data)
    }
  }

  return (
    props.gate ?
      <div
        ref={drag}
        style={{
          opacity: isDragging ? 0.5 : 1,
          cursor: 'move'
        }}
      >
        {props.gate.type == 4 ? <span></span> :
          props.showOptions ?
            <>

              <Listbox value={selected} onChange={setSelected}>
                {({ open }: any) => (
                  <>
                    <div className="relative">
                      <Listbox.Button className='w-10'>
                        <>
                          <span className={`${props.gate.color} w-full items-center rounded-t-md flex relative justify-center h-2`}></span>
                          <div className='z-[2] flex items-center bg-white relative self-center justify-center border border-slate-300 rounded-b-sm'>
                            {props.gate.child}
                          </div>
                        </>
                      </Listbox.Button>


                      <Transition
                        show={open}
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                      >
                        <Listbox.Options className="absolute right-0 z-10 mt-2 origin-top-right divide-y divide-gray-200 overflow-hidden rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                          {publishingOptions.map((option) => (
                            <Listbox.Option
                              key={option.title}
                              className={({ active }) =>
                                classNames(
                                  active ? 'bg-slate-100' : '',
                                  'cursor-default select-none p-2 text-sm text-gray-900'
                                )
                              }
                              onClick={option.handle}
                              value={option}
                            >
                              {({ selected, active }) => (
                                <div className="flex flex-col">
                                  <div className="flex flex-start gap-1">
                                    {option.icon}
                                    <span className={selected ? 'text-sm font-semibold' : 'text-sm font-normal'}>{option.title}</span>
                                  </div>
                                </div>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </>
                )}
              </Listbox>
              {showEditModal ?
                <RotationGateDrawer value={props.gate.ratio} closeModal={() => setShowEditModal(false)} handleSubmit={addRatio} />
                : null}
            </>
            :
            <>
              <span className={`${props.gate.color} w-full items-center rounded-t-md flex relative justify-center h-2`}></span>
              <div className='flex items-center z-[2] bg-white relative self-center justify-center border border-slate-300 rounded-b-sm'>
                {props.gate.child}
              </div>
            </>
        }
      </div>
      : null

  )
}



